"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonStoreFront = void 0;
var angular = require("angular");
var common_1 = require("./common");
var isTouchDevice_1 = require("./directives/isTouchDevice");
var cartApi_1 = require("./services/cartApi");
require("ng-debounce/dist/ng-debounce.js");
exports.commonStoreFront = angular
    .module('common-sf-for-cart', ['eComSFSMCommon', 'debounce', common_1.common])
    .directive('isTouchDevice', isTouchDevice_1.isTouchDevice)
    .service('cartApi', cartApi_1.CartApi).name;
